import { render, staticRenderFns } from "./PreProductList.vue?vue&type=template&id=d58995e2&"
import script from "./PreProductList.vue?vue&type=script&lang=js&"
export * from "./PreProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports